import { useCallback, useEffect, useState } from 'react';

import { buildFunctionUrl } from 'firebaseConfig';
import { isValidEmail, isValidPassword, isValidUserName } from 'utilities/Validators';

const useSignupFormState = ({ onErrorChange }) => {
  const [signupEmail, setSignupEmail] = useState('');
  const [signupName, setSignupName] = useState('');
  const [signupPassword, setSignupPassword] = useState('');
  const [signupFormValid, setSignupFormValid] = useState(false);
  const [emailTaken, setEmailTaken] = useState(false);

  useEffect(() => {
    const validate = () => {
      setSignupFormValid(
        isValidUserName(signupName) &&
        signupEmail.length > 0 &&
        signupPassword.length > 0 &&
        isValidEmail(signupEmail) &&
        isValidPassword(signupPassword) &&
        !emailTaken
      );
    };

    validate();
  }, [emailTaken, signupEmail, signupName, signupPassword]);

  const handleSignupEmailChange = useCallback((e) => {
    setSignupEmail(e.target.value.trim().toLowerCase());
    onErrorChange && onErrorChange(null);
  }, [onErrorChange]);

  const handleSignupEmailBlur = useCallback(async (e) => {
    const email = e.target.value.trim().toLowerCase();

    try {
      const res = await fetch(buildFunctionUrl('checkEmailTaken'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (data.taken) {
        setEmailTaken(true);
        onErrorChange && onErrorChange('Email is already in use.');
      } else {
        setEmailTaken(false);
        onErrorChange && onErrorChange(null);
      }
    } catch (err) {
      console.error('Error:', err.message);
    }
  }, [onErrorChange]);

  const handleSignupNameChange = useCallback((e) => {
    setSignupName(e.target.value);
    onErrorChange && onErrorChange(null);
  }, [onErrorChange]);

  const handleSignupPasswordChange = useCallback((e) => {
    setSignupPassword(e.target.value);
    onErrorChange && onErrorChange(null);
  }, [onErrorChange]);

  const resetSignupForm = useCallback(() => {
    setSignupEmail('');
    setSignupName('');
    setSignupPassword('');
    setSignupFormValid(false);
    setEmailTaken(false);
  }, []);

  return {
    signupEmail,
    signupName,
    signupPassword,
    signupFormValid,
    handleSignupEmailChange,
    handleSignupEmailBlur,
    handleSignupNameChange,
    handleSignupPasswordChange,
    resetSignupForm,
  };
};

export default useSignupFormState;
